import React, { useState,useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Storico from "./pages/Storico";
import AnalisiEconomica from "./pages/analisys";
import AnalisiEconomicaCasa from "./pages/analysis_villa";
import Instructors from "./pages/Instructors";
import IstruttoreLezioni from "./pages/istruttoreLezioni";
import Equipment from "./pages/Equipment";
import Accessori from "./pages/accessories";
import AgendaPrenotazioni from "./pages/prenotazioni_visuale";
import Vs from "./pages/vs";
import Utenti from "./pages/utenti"
import NotFound from "./pages/NotFound";
import { getToken,getSidebar,setSidebar,getRuolo } from "./auth";
import { decriptaRuolo } from "./funzioni/funzioni_utili";
import Sidebar from "./Sidebar";
import "./Global.css";
import Agenda from "./pages/Agenda.jsx"
import AgendaIstruttore from "./pages/agendaistruttore.jsx"
import StoricoVilla from "./pages/storico_villa";
import DashboardOggi from "./pages/planning.jsx"
import AnalisiIstruttore from "./pages/analisiIstruttore";

function App() {
    const DocumentsFallback = () => {
  useEffect(() => {
    // Usa window.location.origin per essere generico (produzione, localhost, ecc.)
    window.location.href = window.location.origin + window.location.pathname;
  }, []);
  return null;
};
    const token = getToken();  // Recupera il token di autenticazione
    var isSidebarOpen=getSidebar() === "true"
    const ruolo=decriptaRuolo(getRuolo(),"scuolaKitesurfKenya")
return (<Router>
        {token && <Sidebar />} {/* Mostra la sidebar solo se il token è valido */}

        <div id="main-content" className={`main-content ${token ? (isSidebarOpen ? "sidebar-open" : "sidebar-closed") : "no-sidebar"}`}>
        <Routes>
    {!token ? (
        // Se non c'è il token, mostra la pagina di login
        <Route path="/login" element={<Login />} />
    ) : (
        // Se c'è il token, mostra le pagine protette
        (ruolo===0 || ruolo===1)?
        (<>
            <Route path="/storico" element={<Storico />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/analysis" element={<AnalisiEconomica />} />
            <Route path="/instructors" element={<Instructors />} />
            <Route path="/accessories" element={<Accessori />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/users" element={<Utenti />} />
            <Route path="/bookingsvilla" element={<AgendaPrenotazioni />} />
            <Route path="/storicovilla" element={<StoricoVilla />} />
            <Route path="/analysisvilla" element={<AnalisiEconomicaCasa />} />
            <Route path="/documents/*"  />
            <Route path="/plan" element={<DashboardOggi />} />
        </>)
        : (
            <>
            <Route path="/instructorstoric" element={<IstruttoreLezioni />} />
            <Route path="/agendainstructor" element={<AgendaIstruttore />} /> />;
            <Route path="/analisisyntructor" element={<AnalisiIstruttore />} /> />

        </>
        )
    )}

    {/* Se l'utente prova ad accedere a /login con il token, viene reindirizzato a /dashboard */}
    <Route path="/login" element={<Navigate to="/storico" />} />

    {/* Rotta di fallback per qualsiasi altro URL */}
    <Route path="*" element={<Navigate to={token ? "/storico" : "/login"} />} />
</Routes>
         </div>
        </Router>
    );
}

export default App;